import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updateEntityDocument } from './documents.service'

export const useEntityDocumentUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateEntityDocument,
    onSuccess: async (_, vars) => {
      await queryClient.invalidateQueries({
        queryKey: ['entityDocuments', vars.entityId],
      })
    },
  })
}
